export const IconIncomplete = `<svg width="21" height="21" viewBox="0 0 21 21" fill="none" xmlns="http://www.w3.org/2000/svg">
<circle cx="10.5" cy="10.5" r="10.5" fill="white"/>
<g clip-path="url(#clip0_182_458)">
<path d="M10.5 0C4.68072 0 0 4.68072 0 10.5C0 16.3193 4.68072 21 10.5 21C16.3193 21 21 16.3193 21 10.5C21 4.68072 16.3193 0 10.5 0ZM14.8012 8.3494L9.67771 13.4729C9.5512 13.5994 9.4247 13.6627 9.23494 13.6627C9.04518 13.6627 8.91867 13.5994 8.79217 13.4729L6.19879 10.753C5.94578 10.5 6.00904 10.1205 6.19879 9.93072C6.45181 9.67771 6.83133 9.74096 7.02108 9.93072L9.17169 12.2078L13.9157 7.46386C14.1687 7.21084 14.5482 7.21084 14.738 7.46386C15.0542 7.71687 15.0542 8.09639 14.8012 8.3494Z" fill="#BBC5D0"/>
</g>
<defs>
<clipPath id="clip0_182_458">
<rect width="21" height="21" fill="white"/>
</clipPath>
</defs>
</svg>

`